import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, delayWhen, map, retry, retryWhen } from 'rxjs/operators';
import { from } from 'rxjs';
import { BedrockRuntimeClient, InvokeModelCommand } from '@aws-sdk/client-bedrock-runtime';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeepPersonalityService {

  private claudeIQ35West: string = 'https://rfxaidg2i5lloyt5xicq532qlm0hmzte.lambda-url.us-west-2.on.aws/';
  private deepSeekR1IQ: string = 'https://ycrkzsuibrf4yozmhvk7patcse0tccaa.lambda-url.us-west-2.on.aws/'; 
  private mistralMonsterIQ: string = 'https://ywizx4foqvvicgvo5od4bs6i7q0mzlxr.lambda-url.us-west-2.on.aws/'; 
  private metaMan: string = 'https://qbun3x5tvfoyma7b7jry2uce6e0uavsn.lambda-url.us-west-2.on.aws/'; 
  private client: BedrockRuntimeClient;
  private maxRetries = 3; // Increased from 2 to 3 
  private summaryLambdaUrl = 'https://bzqjjjrjcgzprndjlghiwxdjuy0mxnfu.lambda-url.us-east-1.on.aws/';
  private modelId: string = 'arn:aws:bedrock:us-west-2:203918849532:inference-profile/us.anthropic.claude-3-5-sonnet-20241022-v2:0';
  private cohere: string = 'https://jc667cdb4ac26ft3uwk5vynzay0afnjg.lambda-url.us-west-2.on.aws/';
  private coherePersonDeep: string = 'https://x7daefznsukybbr5illy67lyvi0cinmr.lambda-url.us-west-2.on.aws/';
  private mistralPersonDeep: string ='https://ncaynbppxr5pv4mi7gr5nplfsm0vhazq.lambda-url.us-west-2.on.aws/';
  private claudePersonDeep: string = 'https://s5yw7nnpy2gln3cc6oklyuz5lm0tlxzd.lambda-url.us-west-2.on.aws/';
  private sonnetPersonDeep: string = 'https://ze2tdyqjxt2gjallf4ynw4vuyi0jnngh.lambda-url.us-west-2.on.aws/';
  private metaPersonDeep: string = 'https://gmblo2xvklwgwocniffik7rrsq0ttmiw.lambda-url.us-west-2.on.aws/';
  private amazonProLambdaUrl: string = 'https://b6qfuzrpm363f46xk7vgddcbb40uhvsh.lambda-url.us-west-2.on.aws/';

  constructor(private http: HttpClient) {

  }

  IQLambdaFunctionClaudius37(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
    
    // Send request with body and add retry logic
    return this.http.post(this.claudeIQ35West, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in Claude IQ call:', error);
        return throwError(() => new Error(`Claude IQ API Error: ${error.message || error}`));
      })
    );
  }
  personLambdaFunctionClaudius37(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
    
    // Send request with body and add retry logic
    return this.http.post(this.claudePersonDeep, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in Claude IQ call:', error);
        return throwError(() => new Error(`Claude IQ API Error: ${error.message || error}`));
      })
    );
  }

  sonnetMonsterPersonAssessment(prompt: string): Observable<any> {
    const requestBody = {
      userprompt: prompt
    };

    return this.http.post(this.sonnetPersonDeep, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in Sonnet personality call:', error);
        return throwError(() => new Error(`Sonnet personality API Error: ${error.message || error}`));
      })
    );
  }

  mistralMonsterIQAssessment(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
    
    // Send request with body and add retry logic
    return this.http.post(this.mistralMonsterIQ, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in Mistral IQ call:', error);
        return throwError(() => new Error(`Mistral IQ API Error: ${error.message || error}`));
      })
    );
  }

  mistralMonsterPersonAssessment(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
    
    // Send request with body and add retry logic
    return this.http.post(this.mistralPersonDeep, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in Mistral IQ call:', error);
        return throwError(() => new Error(`Mistral IQ API Error: ${error.message || error}`));
      })
    );
  }

  cohereMonsterIQAssessment(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
    
    // Send request with body and add retry logic
    return this.http.post(this.cohere, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in cohere IQ call:', error);
        return throwError(() => new Error(`cohere IQ API Error: ${error.message || error}`));
      })
    );
  }
  cohereMonsterPersonAssessment(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
    
    // Send request with body and add retry logic
    return this.http.post(this.coherePersonDeep, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in cohere IQ call:', error);
        return throwError(() => new Error(`cohere IQ API Error: ${error.message || error}`));
      })
    );
  }
  
  seekMonsterIQAssessment(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
   
    // Send request with body and add retry logic
    return this.http.post(this.deepSeekR1IQ, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in DeepSeek IQ call:', error);
        return throwError(() => new Error(`DeepSeek IQ API Error: ${error.message || error}`));
      })
    );
  }

  metaManIQAssessment(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
   
    // Send request with body and add retry logic
    return this.http.post(this.metaMan, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in Meta IQ call:', error);
        return throwError(() => new Error(`Meta IQ API Error: ${error.message || error}`));
      })
    );
  }

  metaManPersonAssessment(prompt: string): Observable<any> {
    // Create request body with the prompt
    const requestBody = {
      userprompt: prompt
    };
   
    // Send request with body and add retry logic
    return this.http.post(this.metaPersonDeep, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in Meta IQ call:', error);
        return throwError(() => new Error(`Meta IQ API Error: ${error.message || error}`));
      })
    );
  }

  amazonProMyerBriggsPersonAssessment(prompt: string): Observable<any> {
    const requestBody = {
      userprompt: prompt
    };

    return this.http.post(this.amazonProLambdaUrl, requestBody).pipe(
      retryWhen(errors => this.retryStrategy(errors)),
      catchError(error => {
        console.error('Error in Amazon Pro IQ call:', error);
        return throwError(() => new Error(`Amazon Pro IQ API Error: ${error.message || error}`));
      })
    );
  }


  callCombinedSummary(
    prompt: string,
    data: Record<string, any>
  ): Observable<any> {
    const body = { prompt, data };
  
    return this.http
      .post<any>(this.summaryLambdaUrl, body, {
        headers: { 'Content-Type': 'application/json' }
      })
      .pipe(
        map((response) => this.normalizeCombinedSummaryResponse(response)),
        retryWhen(errors => this.retryStrategy(errors)),
        catchError(error => {
          console.error('Error in summary lambda call:', error);
          return throwError(() => new Error(`Summary Lambda Error: ${error.message || error}`));
        })
      );
  }

  private normalizeCombinedSummaryResponse(response: any): any {
    // Supports both direct JSON payloads and Lambda proxy envelopes ({ statusCode, body: "..." }).
    if (response && typeof response === 'object' && typeof response.body === 'string') {
      try {
        const parsedBody = JSON.parse(response.body);
        return parsedBody && typeof parsedBody === 'object' ? parsedBody : response;
      } catch {
        return response;
      }
    }

    return response;
  }



  getMultiModelSummary(prompt: string, data: any): Observable<string> {
    const messages = [
      { role: "user", content: `\n\nHuman: Given the data: \${JSON.stringify(data)}, \${prompt}\n\nAssistant:` }
    ];

    const body = {
      anthropic_version: 'bedrock-2023-05-31',
      messages: messages,
      max_tokens: 1024
    };

    const requestParams = {
      modelId: this.modelId,
      contentType: 'application/json',
      accept: 'application/json',
      headers: {
        'Content-Type': 'application/json',
        'anthropic-version': 'bedrock-2023-05-31'
      },
      body: JSON.stringify(body)
    };

    return from(this.client.send(new InvokeModelCommand(requestParams))).pipe(
      map(response => {
        try {
          const responseBody = response.body ? new TextDecoder().decode(response.body) : '{}';
          const parsedResponse = JSON.parse(responseBody);

          if (parsedResponse && parsedResponse.content && parsedResponse.content.length > 0) {
            const textContent = parsedResponse.content[0].text;
            return textContent;
          } else {
            throw new Error('Content is missing in the response');
          }
        } catch (error) {
          console.error('Error parsing response:', error);
          return throwError(() => new Error('Failed to parse response'));
        }
      }),
      catchError(error => {
        console.error('Error in Bedrock call:', error);
        return throwError(() => new Error(`Bedrock API Error: ${error.message || error}`));
      }),
      retryWhen(errors => this.retryStrategy(errors))
    );
  }
  
  // Implemented exponential backoff retry strategy
  private retryStrategy(errors: Observable<any>): Observable<any> {
    return errors.pipe(
      delayWhen((error, attempt) => {
        const retryAttempt = attempt + 1;
        if (retryAttempt > this.maxRetries) {
          return throwError(() => new Error(`Max retry attempts reached (\${this.maxRetries})`));
        }
        
        // Calculate delay with exponential backoff (300ms, 900ms, 2700ms)
        const delay = Math.pow(3, retryAttempt) * 100;
        console.log(`Attempt ${retryAttempt}: retrying in \${delay}ms`);
        
        // Return a timer that will emit after the delay
        return timer(delay);
      })
    );
  }
}
